<template>
  <div id="app">
    <!-- pwa环境下的模拟chrome导航栏 -->
    <Tabs v-if="isPwa" />

    <!-- pwa环境下tab iframe装载 -->
    <iframe :ref="`iframe-${item.id}`" v-for="item in showIframeList" :key="item.id" v-show="activeTabId === item.id"
      :src="item.src"></iframe>

    <!-- 用于检测本地应用是否能打开 -->
    <input class="hiddenInput" ref="hiddenInput" type="text" @blur="blur" @focus="focus" />

    <!-- 用来装微信那些内部打开应用，优化打开体验 -->
    <iframe style="height: 0px; display: none;" @load="onload" :ref="`iframe-${item.id}`"
      v-for="item in interIframeList" :key="item.id + `${iframeKey}`"
      :src="`https://www.baidu.com` && item.src"></iframe>

    <router-view v-show="activeTabId == -1 || !isPwa" />
  </div>
</template>

<script>
import { isPwa } from "@/utils/tools";
import Tabs from "@/components/common/Tabs"
// import DevicePixelRatio from '@/utils/DevicePixelRatio.js';

export default {
  name: "App",
  components: {
    Tabs,
  },
  data() {
    return {
      isPwa: false,
      key: -1,
      blurStatus: false,
    };
  },
  beforeCreate() {

  },
  mounted() {
    //解决部分笔记本默认150%缩放导致页面变形的问题
    // new DevicePixelRatio().init();

    // this.$nextTick(() => {
    //   let percentage, appHeight = 768;//设置默认屏幕大小
    //   percentage = window.innerHeight * 100 / appHeight;
    //   percentage = Math.floor(percentage) / 100;
    //   document.documentElement.style.zoom = percentage;
    // })


    window.onresize = () => {
      this.$store.commit("setAppStatus", {
        isPwa: isPwa(),
      });
      if (isPwa()) {
        document.title = "大白身份云服务";
      }
    };

    // 一些禁止动作
    document.onkeydown = () => {
      //开发测试环境不限制
      if (window.location.origin.indexOf('http://localhost:') !== -1 || window.location.origin.indexOf('https://test.idaas.dabby.com.cn/') !== -1) return;

      //禁用F12
      if (window.event && window.event.keyCode == 123) {
        this.$message.warning('^_^');
        return false;
        //禁用ctrl+shift+i,
      } else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
        return false;
        //屏蔽Shift+F10
      } else if (window.event.shiftKey && window.event.keyCode == 121) {
        return false;
      }
    };
  },
  computed: {
    showIframeList: ({ $store }) =>
      $store.state.tabs.filter(({ id }) => id !== -1),

    activeTabId: ({ $store }) => $store.state.activeTabId,

    interIframeList: ({ $store }) => $store.state.interIframeList,

    iframeKey({ $store }) {
      const input = this.$refs.hiddenInput;
      requestAnimationFrame(() => {
        input.focus();
        setTimeout(() => {
          if (!this.blurStatus) {
            this.$message.warning("打开应用超时，请查看是否安装了应用");
          }
        }, 2000);
      });
      return $store.state.iframeKey;
    },
  },
  methods: {
    onload(e) {
      console.log("error", e);
    },
    blur() {
      this.blurStatus = true;
    },
    focus() {
      this.blurStatus = false;
    },
  },
};
</script>

<style>
#app {
  position: absolute;
  width: 100%;
  height: 100%;
}

iframe {
  width: 100%;
  height: calc(100vh - 44px);
}

.main {
  height: calc(100vh - 44px);
}

.hiddenInput {
  width: 0px;
  height: 0px;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
}

/* CSS Reset */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: null;
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

div {
  box-sizing: border-box;
}

/* end */

* {
  font-family: "PingFangSC-Regular", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

html {
  font-size: 62.5% !important;
}

/* @media only screen and (min-width: 1081px) and (max-width: 1463px) {
  html {
    font-size: 50% !important;
  }
} */

::-webkit-scrollbar-track-piece {
  background-color: #f8f8f8;
}

::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

:root {
  --border--base: #dfe0e2;
  --border--blue: #3978ff;
  --text--blue: #3978ff;
  --text--red: #fc423c;
  --bg--grey: #f5f7fa;
  --bg--white: #fff;
  --bg--blue: #3978ff;
  --bg--red: #fc423c;
  --bg--green: #3dcc2a;
  --block--radius: 1.2rem;
}

.block-box {
  background-color: var(--bg--white);
  margin: 1rem 2rem;
  border-radius: 0.4rem;
  overflow: hidden;
}

.page-title {
  font-size: 1.6rem;
  color: #1f2635;
  padding: 0 2.4rem;
  height: 6.2rem;
  border-bottom: 1px solid var(--border--base);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.page-title h2 {
  flex: 1;
}

.action-box .el-button--small {
  padding: 0.8rem 1.6rem;
}

.el-button--small {
  font-size: 1.4rem;
}

.el-button--small i {
  font-size: 1.4rem;
}

.el-input--small {
  font-size: 1.4rem;
}

.action-box .el-button--primary.is-plain {
  color: var(--text--blue);
  border-color: var(--border--blue);
  background: #fff;
}

.action-box .el-button--primary.is-plain:hover {
  background: var(--bg--blue);
  color: #fff;
}

.el-dropdown {
  cursor: pointer;
}

.space-box {
  display: inline-block;
  width: 1rem;
  height: 1rem;
}

.el-table td .cell {
  font-size: 1.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-table th.el-table__cell {
  background-color: #f6f7f9;
  border-radius: 4px 4px 0px 0px;
  font-size: 1.4rem;
  font-weight: 400;
  color: #5e626d;
}

.el-table-column--selection .cell {
  text-align: center;
}

.el-table td.el-table__cell {
  padding: 0.95rem 0;
}

.pages-box {
  text-align: right;
  padding: 0 2.4rem 2rem 2.4rem;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: 1px solid var(--border--base);
  border-radius: 0.4rem;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fff;
  border-color: var(--border--blue);
  color: var(--text--blue);
}

.el-pagination__jump {
  margin-left: 1rem;
}

.el-submenu__title i,
.el-menu-item i {
  color: #8f929a;
}

.el-dialog {
  border-radius: 8px;
}

.el-dialog .el-dialog__title {
  font-size: 1.8rem;
  color: #1f2635;
  font-weight: bold;
}

.el-dialog .el-dialog__headerbtn {
  font-size: 2rem;
}

.el-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #5f6574;
}

.v-modal {
  opacity: 0.45;
}

.el-message-box {
  border-radius: 0.8rem;
  padding-bottom: 1.5rem;
}

.el-message-box__title {
  font-size: 1.8rem;
  color: #1f2635;
  font-weight: bold;
}

.el-message-box__content {
  min-height: 60px;
}

.el-message-box__headerbtn {
  font-size: 2rem;
}

.el-message-box__headerbtn .el-message-box__close {
  color: #5f6574;
}

.el-button--primary.is-plain {
  background: #fff;
  color: var(--text--blue);
}

.el-button--primary.is-plain:hover {
  background: var(--bg--blue);
  color: #fff;
}

.el-checkbox__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-radius: 50%;
  width: 16px !important;
  height: 16px !important;
}

.el-checkbox__inner::after {
  top: 2px;
  left: 5px;
}

.empty-box {
  width: 100%;
  height: 50rem;
  background: url("./assets/images/empty_img.png") no-repeat center center;
  padding-top: 37rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  color: #5e626d;
  text-align: center;
}

.el-popconfirm .el-popconfirm__main {
  padding: 1rem 0 2rem 0;
}

.el-dialog__body {
  /* max-height: 60vh; */
  overflow: auto;
  padding-top: 0;
}

.el-dialog__body::-webkit-scrollbar {
  display: none;
}

/* 隐藏和风天气字眼 */
.wv-lt-refresh {
  display: none !important;
}

.wv-lt-location>a {
  display: none !important;
}

@media screen and (max-width: 1080px) {
  .el-message-box {
    max-width: 80%;
  }
}

@media screen and (max-width: 780px) {
  body {
    padding-right: 0px !important;
  }
}

@media all and (-moz-min-device-pixel-ratio: 1.09) and (-moz-max-device-pixel-ratio: 1.18),
(-webkit-min-device-pixel-ratio: 1.09) and (-webkit-max-device-pixel-ratio: 1.18),
(min-resolution: 1.09dppx) and (max-resolution: 1.18dppx) {
  :root {
    font-size: 14px;
  }
}

@media all and (-moz-min-device-pixel-ratio: 1.19) and (-moz-max-device-pixel-ratio: 1.28),
(-webkit-min-device-pixel-ratio: 1.19) and (-webkit-max-device-pixel-ratio: 1.28),
(min-resolution: 1.19dppx) and (max-resolution: 1.28dppx) {
  :root {
    font-size: 13px;
  }
}

@media all and (-moz-min-device-pixel-ratio: 1.29) and (-moz-max-device-pixel-ratio: 1.4),
(-webkit-min-device-pixel-ratio: 1.29) and (-webkit-max-device-pixel-ratio: 1.4),
(min-resolution: 1.29dppx) and (max-resolution: 1.4dppx) {
  :root {
    font-size: 12px;
  }
}

@media all and (-moz-min-device-pixel-ratio: 1.41) and (-moz-max-device-pixel-ratio: 1.6),
(-webkit-min-device-pixel-ratio: 1.41) and (-webkit-max-device-pixel-ratio: 1.6),
(min-resolution: 1.41dppx) and (max-resolution: 1.6dppx) {
  :root {
    font-size: 10px;
  }
}

@media all and (-moz-min-device-pixel-ratio: 1.61) and (-moz-max-device-pixel-ratio: 1.8),
(-webkit-min-device-pixel-ratio: 1.61) and (-webkit-max-device-pixel-ratio: 1.8),
(min-resolution: 1.61dppx) and (max-resolution: 1.8dppx) {
  :root {
    font-size: 9px;
  }
}

@media all and (-moz-min-device-pixel-ratio: 1.81) and (-moz-max-device-pixel-ratio: 2.1),
(-webkit-min-device-pixel-ratio: 1.81) and (-webkit-max-device-pixel-ratio: 2.1),
(min-resolution: 1.81dppx) and (max-resolution: 2.1dppx) {
  :root {
    font-size: 8px;
  }
}
</style>